import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { MenuItem } from 'primeng/api';

@Injectable({
  providedIn: 'root'
})
export class PageTitleService {
  private pageTitleSubject = new BehaviorSubject<string | null>(null);
  public pageTitle$: Observable<string | null> = this.pageTitleSubject.asObservable();

  private pageSubtitleSubject = new BehaviorSubject<string | null>(null);
  public pageSubtitle$: Observable<string | null> = this.pageSubtitleSubject.asObservable();

  private examStatusSubject = new BehaviorSubject<'UNSAVED' | 'BOZZA' | 'COMPLETATO' | null>(null);
  public examStatus$: Observable<'UNSAVED' | 'BOZZA' | 'COMPLETATO' | null> = this.examStatusSubject.asObservable();

  private customBreadcrumbsSubject = new BehaviorSubject<MenuItem[] | null>(null);
  public customBreadcrumbs$: Observable<MenuItem[] | null> = this.customBreadcrumbsSubject.asObservable();

  setPageTitle(title: string | null): void {
    this.pageTitleSubject.next(title);
  }

  setPageSubtitle(subtitle: string | null): void {
    this.pageSubtitleSubject.next(subtitle);
  }

  setPageTitleAndSubtitle(title: string | null, subtitle: string | null): void {
    this.pageTitleSubject.next(title);
    this.pageSubtitleSubject.next(subtitle);
  }

  setExamStatus(status: 'UNSAVED' | 'BOZZA' | 'COMPLETATO' | null): void {
    this.examStatusSubject.next(status);
  }

  getCurrentTitle(): string | null {
    return this.pageTitleSubject.value;
  }

  getCurrentSubtitle(): string | null {
    return this.pageSubtitleSubject.value;
  }

  getCurrentExamStatus(): 'UNSAVED' | 'BOZZA' | 'COMPLETATO' | null {
    return this.examStatusSubject.value;
  }

  clearPageTitle(): void {
    this.pageTitleSubject.next(null);
  }

  clearPageSubtitle(): void {
    this.pageSubtitleSubject.next(null);
  }

  clearExamStatus(): void {
    this.examStatusSubject.next(null);
  }

  clearAll(): void {
    this.pageTitleSubject.next(null);
    this.pageSubtitleSubject.next(null);
    this.examStatusSubject.next(null);
    this.customBreadcrumbsSubject.next(null);
  }

  setCustomBreadcrumbs(breadcrumbs: MenuItem[] | null): void {
    this.customBreadcrumbsSubject.next(breadcrumbs);
  }

  clearCustomBreadcrumbs(): void {
    this.customBreadcrumbsSubject.next(null);
  }

  getCurrentCustomBreadcrumbs(): MenuItem[] | null {
    return this.customBreadcrumbsSubject.value;
  }
}
